import { Dictionary } from "../../DiscoveryEngine.TS/Utils";
import { AccountType, DirectoryGroupsDto } from "../../UvExplorerServer.Dtos.TS/Auth";


export class DirectoryGroupsCacheEntry {

	// domain name => directory groups
	private map: Dictionary<string, DirectoryGroupsDto>;

	constructor() {
		this.map = new Dictionary<string, DirectoryGroupsDto>();
	}

	public add(domainName: string, dirGroups: DirectoryGroupsDto): void {
		this.map.Add(domainName, dirGroups);
	}

	public contains(domainName: string): boolean {
		return this.map.ContainsKey(domainName);
	}

	public get(domainName: string): DirectoryGroupsDto {
		if (this.contains(domainName)) {
			return this.map.Item(domainName);
		}
		else {
			return null;
		}
	}
}


export class DirectoryGroupsCache {

	private map: Dictionary<AccountType, DirectoryGroupsCacheEntry> =
		new Dictionary<AccountType, DirectoryGroupsCacheEntry>();

	constructor() {
		return;
	}

	public clear(): void {
		this.map.Clear();
	}

	public add(accountType: AccountType, domainName: string, dirGroups: DirectoryGroupsDto): void {
		let entry: DirectoryGroupsCacheEntry = null;

		if (this.map.ContainsKey(accountType)) {
			entry = this.map.Item(accountType);
		}

		if (!entry) {
			entry = new DirectoryGroupsCacheEntry();
			this.map.Add(accountType, entry);
		}

		entry.add(domainName, dirGroups);
	}

	public contains(accountType: AccountType, domainName: string): boolean {
		return !!this.get(accountType, domainName);
	}

	public get(accountType: AccountType, domainName: string): DirectoryGroupsDto {
		let dirGroups: DirectoryGroupsDto = null;

		if (this.map.ContainsKey(accountType)) {
			let entry: DirectoryGroupsCacheEntry = this.map.Item(accountType);

			if (entry.contains(domainName)) {
				dirGroups = entry.get(domainName);
			}
		}

		return dirGroups;
	}

	public remove(accountType: AccountType): void {
		this.map.Remove(accountType);
	}

}
